import { Text } from "@fluentui/react-components";
import { BoxProps } from "./box.types";
import { translate } from "@/config/translator";
import { PspContext } from "@/config/contexts";
import { PropsWithChildren, useContext } from "react";
import { useIsTablet } from "@/config/hooks";
import { clsx } from "clsx/lite";

export default function Box({
  title,
  secondaryText,
  className,
  children,
  showBottomMessage,
  bottomMessage,
  topRight,
  gray,
}: PropsWithChildren<BoxProps>) {
  const { lang } = useContext(PspContext);
  const isTablet = useIsTablet();

  if (isTablet)
    return (
      <>
        <div className={className}>
          <div
            className={clsx(
              "shadow-xs",
              "border-neutral",
              "border",
              "p-4",
              "rounded-lg",
              gray ? "bg-canvas-secondary" : "bg-white",
            )}
          >
            {(title || secondaryText || topRight) && (
              <div className="flex flex-row justify-between items-start">
                <div className="pb-6 flex flex-col gap-1">
                  {title && <h2 className="font-semibold text-xl">{title}</h2>}
                  {secondaryText && (
                    <p className="text-sm text-font-secondary">
                      {secondaryText}
                    </p>
                  )}
                </div>
                <div>{topRight}</div>
              </div>
            )}
            <div className="text-left">{children}</div>
          </div>
          {showBottomMessage && bottomMessage && (
            <div>
              <Text className="text-font-secondary">
                {translate(bottomMessage, lang)}
              </Text>
            </div>
          )}
        </div>
      </>
    );

  return <div>{children}</div>;
}
